/** @format */
import React from "react";
import { useNavigate } from "react-router-dom";

import { Box, FormControl, FormHelperText, FormLabel, Input, InputProps } from "@mui/material";

import "./input.css";

type LabelAlignment = "top" | "left";

interface InputStyleProps {
  labelAlign?: LabelAlignment;
}

export interface CommonInputProps extends InputStyleProps, InputProps {
  label?: string;
  ref?: React.Ref<HTMLInputElement>;
  className?: string;
  helperText?: string;
  linkBesideLabel?: Boolean;
  link?: string;
  linkName?: string;
  maxLength?: number;
  type?: string;
  sx?: boolean | any;
  removeBottomMargin?: boolean;
}

const CommonInput = React.forwardRef<HTMLInputElement, CommonInputProps>(
  (
    {
      label = false,
      labelAlign = "top",
      className,
      helperText,
      maxLength,
      type = "text",
      link,
      linkBesideLabel = false,
      linkName,
      sx = false,
      removeBottomMargin = false,
      ...props
    },
    ref,
  ) => {
    const { fullWidth, disabled, error, required, id } = props;
    const navigate = useNavigate();
    const matcher = (event: any) => {
      const allowedRegex = /[^eE!@#$%^&*()_+]/g;
      if (!event.key.match(allowedRegex)) {
        event.preventDefault();
      }
    };

    return (
      <FormControl
        error={error}
        required={required}
        disabled={disabled}
        fullWidth={fullWidth}
        className={`form ${removeBottomMargin == false && 'input-margin-bottom'}`}
      >
        {label && (
          <div className='flex justify-center'>
            <FormLabel
              disabled={disabled}
              error={error}
              required={false}
              htmlFor={id}
              className={`${sx ? "sx-input-label" : "input-label"}`}
            >
              {label + `${labelAlign === "left" ? ": " : ""}`}
              {required && <span className='MuiFormLabel-asterisk'> * </span>}
              {linkBesideLabel && (
                <a
                  onClick={(e) => navigate(`${link}`)}
                  className='link hover:cursor-pointer text-[#7E7E7E] text-lg font-normal'
                >
                  {linkName}
                </a>
              )}
            </FormLabel>
          </div>
        )}
        <div className='flex justify-center'>
          <Box borderRadius='8px' className={className}>
            <Input
              required={required}
              disabled={disabled}
              ref={ref}
              id={id}
              error={error}
              {...props}
              disableUnderline
              type={type}
              // className={`${sx ? "sx-custom-input" : (inputClassName ? inputClassName : "")}`}
              inputProps={{
                maxLength: maxLength,
              }}
              onKeyDown={(e) => (type === "number" ? matcher(e) : null)}
            />
          </Box>
        </div>
        <FormHelperText error={error} className='input-helper-text'>
          {helperText}
        </FormHelperText>
      </FormControl>
    );
  },
);

export default CommonInput;
